/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import "./modalAccountWallet.scss"
import { useConnectWallet }  from "../../hooks/useConnectWallet"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faTimes, faTimesCircle ,faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import {
  faClone ,
} from '@fortawesome/free-regular-svg-icons'
import { getEtherscanLink } from "../../utils"
import { CopyToClipboard } from 'react-copy-to-clipboard'


const ModalAccountWallet  = (props:any) => {
  const {
    buttonLabel,
    className,
    isShowModal,
    onCloseModal
  } = props;

  const toggle = () => onCloseModal()
  const { disconnectWallet,  account, chainId} = useConnectWallet()


  const onLogout = () => {
    disconnectWallet()
    onCloseModal()
  } 


  return (
    <div>

      <Modal isOpen={isShowModal} toggle={toggle} className="modal-account-detail">
    
      <div className="modal-header">
          <h5 className="modal-title">Your wallet</h5>
          <button type="button"  
             onClick={toggle}
             className="btn close" aria-label="Close">
               <FontAwesomeIcon icon={faTimes} />
          </button>
       </div>

        <ModalBody>

            <div className="d-flex  flex-column  justify-content-center warp-account-detail " > 
               
                <div className="d-flex flex-column  justify-conten-center warp-address" > 
                    <label  className="text-align-center account-detail-text label-address" >{  account  }</label>
                </div>


                <div className="mt-10  d-flex flex-column  justify-conten-center" > 
                    <div className="d-flex flex-row  wrap-bsc-detail  ">
                    <CopyToClipboard text={account}>
                          <button className="btn copy-btn"  >  
                           Copy Address
                            <FontAwesomeIcon icon={faClone} />
                        </button> 
                      </CopyToClipboard>


                        <a className="btn external-link-btn"
                            href={chainId && getEtherscanLink(chainId, account, 'address')}
                        >  
                            View on bscscan
                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                        </a>

                    </div>
                </div>


                <div className="mt-10  d-flex flex-column  justify-content-center align-items-center text-align-center warp-logut-btn" >
                         <button  onClick={onLogout}  className="btn logout-btn"  > Logout </button>
                </div>

            </div>
        </ModalBody>

      </Modal>
    </div>
  );
}

export default  ModalAccountWallet ;







